import React, { useState } from 'react';
import { Grid, TextField, Button, Box } from '@material-ui/core';
import { FormStatus, PaymentMethod, formatBillingAddress } from '@lib/state';
import { PaymentMethodModal } from './payment-method.modal';
import { ErrorDisplay } from '@lib/common';

interface Props {
  paymentMethod: PaymentMethod;
  onDelete: () => void;
  status: FormStatus;
  error?: Error;
}

export const PaymentMethodComponent: React.FC<Props> = ({
  paymentMethod,
  onDelete,
  status,
  error,
}) => {
  const [showPaymentMethodModal, setShowPaymentMethodModal] = useState(false);

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <TextField
            value={`•••• •••• •••• ${paymentMethod.cardLastFour}`}
            label="Card Number"
            fullWidth
            disabled
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <TextField
            value={`${paymentMethod.expirationMonth}/${paymentMethod.expirationYear}`}
            label="Exp Date"
            fullWidth
            disabled
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <TextField value={`•••`} label="CVC" fullWidth disabled />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Billing Address"
            value={formatBillingAddress(paymentMethod.billingAddress)}
            fullWidth
            disabled
            multiline
          />
        </Grid>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end">
            <ErrorDisplay error={error} />
            <Button size="small" color="secondary" variant="contained" onClick={() => onDelete()}>
              Delete
            </Button>
            {/* 
             // Edit button is not in prototype.
            <Button
              size="small"
              color="secondary"
              variant="contained"
              onClick={() => setShowPaymentMethodModal(true)}
            >
              Edit
            </Button> */}
          </Box>
        </Grid>
      </Grid>

      {showPaymentMethodModal && (
        <PaymentMethodModal
          show={showPaymentMethodModal}
          onClose={() => setShowPaymentMethodModal(false)}
          paymentMethod={paymentMethod}
        />
      )}
    </>
  );
};
